/* eslint-disable react-refresh/only-export-components */

import { createFileRoute, Outlet } from '@tanstack/react-router';
import { Permission } from '../../../features/common/permision';

export const Route = createFileRoute('/_creator-center/admin/statistics')({
  pendingComponent: () => null,
  staticData: { permissions: [Permission.资产管理] },
  component: Statistics,
});

function Statistics() {
  return <Outlet></Outlet>;
}
